// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3_cwb","select":"Header_select__3fEjl","clinic":"Header_clinic__3QZ_W"};